import { WarrantyLogModel } from '../../model/types';
import { useEditModalStore } from '../../model/use-edit-modal.store';
import { useWarrantyLogsModalStore } from '../../model/use-warranty-logs-modal.store';
import { warrantyLogContext } from '../../model/warranty-log-context';
import { WarrantyLogsCreateModal } from '../create/modal';
import { WarrantyLogsEditModal } from '../edit/modal';
import { TableColumns } from './columns';
import { ListPagination } from './list-pagination';
import styles from './styles.module.scss';
import { Loading } from 'components/loading';
import { CustomHeaderColumn } from 'components/table/columns/custom-header-column';
import { useQueryResponseData, useQueryResponseLoading } from 'components/table/contexts/query-response';
import { CustomRow } from 'components/table/rows/custom-row';
import { useEffect, useMemo } from 'react';
import { ColumnInstance, Row, useTable } from 'react-table';

export const WarrantyLogsTable = () => {
  const { isShowCreateModal, closeCreateModal } = useWarrantyLogsModalStore();
  const { isShowEditModal, closeModal: closeEditModal } = useEditModalStore();

  useEffect(() => () => closeCreateModal(), [closeCreateModal]);
  useEffect(() => () => closeEditModal(), [closeEditModal]);

  const data = useQueryResponseData(warrantyLogContext);
  const isLoading = useQueryResponseLoading(warrantyLogContext);
  const columns = useMemo(() => TableColumns, []);
  const { getTableProps, getTableBodyProps, headers, rows, prepareRow } = useTable({
    columns,
    data
  });

  return (
    <>
      <div className={styles.container}>
        <div className="table-responsive">
          <table
            id="kt_table_enquiryManager"
            className="table align-middle table-row-bordered fs-7 gy-5 dataTable no-footer"
            {...getTableProps()}
          >
            <thead>
              <tr className="text-start text-gray-800 align-middle fs-7 fw-bold gs-0">
                {headers.map((column: ColumnInstance<WarrantyLogModel>) => (
                  <CustomHeaderColumn key={column.id} column={column} />
                ))}
              </tr>
            </thead>
            <tbody className="text-gray-600 fw-bold" {...getTableBodyProps()}>
              {rows.length > 0 ? (
                rows.map((row: Row<WarrantyLogModel>, i) => {
                  prepareRow(row);
                  return <CustomRow row={row} key={`row-${i}-${row.id}`} />;
                })
              ) : (
                <tr>
                  <td colSpan={headers.length}>
                    <div className="d-flex text-center w-100 align-content-center justify-content-center">
                      No matching records found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <ListPagination queryResponseContext={warrantyLogContext} />
        {isLoading && (
          <div className={styles.loadingContainer}>
            <div className={styles.overlay}></div>
            <Loading />
          </div>
        )}
      </div>
      {isShowCreateModal && <WarrantyLogsCreateModal />}
      {isShowEditModal && <WarrantyLogsEditModal />}
    </>
  );
};
